export const formatFirstString = (fullName: string) => {
  const nameCapitalize = fullName.toLowerCase().replace(/(?:^|\s)\S/g, (a) => {
    return a.toUpperCase();
  });
  return nameCapitalize;
};
